import { canMakeApplePayPayments } from '@/components/_shared/payments'

export default {
  data() {
    return {
      merchantIdentifier: window.CHECKOUT_APPLE_PAY_MERCHANT_ID,
    }
  },

  methods: {
    initApplePayExpressCheckout(options = {}) {
      const loadApplePayData = options.loadApplePayData || false
      const setApplePayUser = () => {
        canMakeApplePayPayments({
          applePayMerchantIdentifier: this.merchantIdentifier,
          onResult: success => {
            if (success) {
              this.$store.commit('checkout/setApplePayUser', true)
            }
          },
        })
      }

      if (loadApplePayData) {
        this.loadApplePayData(setApplePayUser)
      } else {
        setApplePayUser()
      }
    },
    loadApplePayData(onLoaded) {
      this.$store.dispatch('checkout/updateApplePayExpressCheckoutRequest', {
        onLoaded,
      })
    },
  },
}
